var _desc, _defs, _path, _path2, _g, _g2, _g3, _path3, _path4, _rect, _rect2, _path5, _rect3, _path6, _rect4, _path7, _rect5, _path8, _rect6, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlgopackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 654,
    height: 72,
    viewBox: "0 0 654 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Created with Pixso.\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_11184_24264_0",
    x1: 11.992668,
    y1: 0,
    x2: 11.992668,
    y2: 48.000008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_11184_24265_0",
    x1: 5.996334,
    y1: -36.000008,
    x2: 5.996334,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_11184_24266_0",
    x1: 5.996334,
    y1: -24.000004,
    x2: 5.996334,
    y2: 24.000004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_11184_24267_0",
    x1: 5.996334,
    y1: -24.000004,
    x2: 5.996334,
    y2: 24.000004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_11184_24268_0",
    x1: 5.996334,
    y1: -36.000008,
    x2: 5.996334,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_11184_24269_0",
    x1: 59.963371,
    y1: 72,
    x2: 59.963371,
    y2: 120.000008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_11184_24270_0",
    x1: 59.963367,
    y1: 23.999994,
    x2: 59.963367,
    y2: 72.000008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_11184_24271_0",
    x1: 71.955551,
    y1: 0,
    x2: 71.955551,
    y2: 72.000008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_11184_24271_1",
    x1: 71.955551,
    y1: 0,
    x2: 71.955551,
    y2: 72.000008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_11184_24274_0",
    x1: 71.956917,
    y1: 24,
    x2: 71.956917,
    y2: 71.994919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4163BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047FF",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4786",
    d: "M5 72L23.9854 72L23.9854 48L0 48L0 67C0 69.7617 2.23853 72 5 72Z",
    fill: "url(#paint_linear_11184_24264_0)",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4787",
    d: "M0 36L11.9927 36L11.9927 24L5 24C2.23853 24 0 26.2383 0 29L0 36Z",
    fill: "url(#paint_linear_11184_24265_0)",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4790",
    width: 11.992666,
    height: 12.000002,
    transform: "matrix(1 0 0 -1 0 48)",
    fill: "url(#paint_linear_11184_24266_0)",
    fillOpacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4791",
    width: 11.992666,
    height: 12.000002,
    transform: "matrix(1 0 0 -1 11.9922 48)",
    fill: "url(#paint_linear_11184_24267_0)",
    fillOpacity: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4792",
    width: 11.992666,
    height: 12.000002,
    transform: "matrix(1 0 0 -1 11.9922 36)",
    fill: "url(#paint_linear_11184_24268_0)",
    fillOpacity: 1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4788",
    d: "M42.9707 72L23.9854 72L23.9854 48L47.9707 48L47.9707 67C47.9707 69.7617 45.7322 72 42.9707 72Z",
    fill: "url(#paint_linear_11184_24269_0)",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4789",
    d: "M47.9707 48L23.9854 48L23.9854 24L42.9707 24C45.7322 24 47.9707 26.2383 47.9707 29L47.9707 48Z",
    fill: "url(#paint_linear_11184_24270_0)",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4763",
    x: 35.977539,
    rx: 5.000001,
    width: 71.956001,
    height: 72.000008,
    fill: "url(#paint_linear_11184_24271_0)",
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4763",
    x: 35.977539,
    rx: 5.000001,
    width: 71.956001,
    height: 72.000008,
    fill: "url(#paint_linear_11184_24271_1)",
    fillOpacity: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 218",
    d: "M63.9609 23L74.9541 36L63.9609 49L63.9609 50L69.9573 50L81.95 36L69.9573 22L63.9609 22L63.9609 23Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4764",
    x: 79.951172,
    y: 46,
    width: 15.990223,
    height: 4.000001,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M43.1987 71.9951C39.1858 71.8486 35.9775 68.5488 35.9775 64.5L35.9775 24L42.9707 24C45.7322 24 47.9707 26.2383 47.9707 29L47.9707 67C47.9707 69.6846 45.8542 71.876 43.1987 71.9951Z",
    clipRule: "evenodd",
    fill: "url(#paint_linear_11184_24274_0)",
    fillOpacity: 0.6,
    fillRule: "evenodd"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4708",
    x: 47.970703,
    y: 48,
    width: 11.992667,
    height: 12.000002,
    transform: "rotate(180 47.970703 48.000000)",
    fill: "#FFBF00",
    fillOpacity: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4710",
    d: "M35.9775 72L42.9702 72C45.7317 72 47.9702 69.7617 47.9702 67L47.9702 60L35.9775 60L35.9775 72Z",
    fill: "#FE6400",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4765",
    width: 11.992667,
    height: 12.000002,
    transform: "matrix(1 0 0 -1 35.9775 60)",
    fill: "#FF3705",
    fillOpacity: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4729",
    d: "M47.9707 36L35.978 36L35.978 24L42.9707 24C45.7322 24 47.9707 26.2383 47.9707 29L47.9707 36Z",
    fill: "#00B3FF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4709",
    x: 47.970703,
    y: 48,
    width: 11.992667,
    height: 12.000002,
    transform: "rotate(180 47.970703 48.000000)",
    fill: "#00FFC2",
    fillOpacity: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M289.698 43.1494C289.565 27.9883 299.252 18.2607 312.788 18.4287C326.324 18.2607 336.077 27.9883 335.911 43.1494C336.077 58.3105 326.324 68.0381 312.788 67.8701C299.252 68.0381 289.565 58.3105 289.698 43.1494ZM312.456 59.6523L313.153 59.6523C321.613 59.6523 326.722 53.4141 326.722 43.1494C326.722 32.8516 321.613 26.6797 313.153 26.6797L312.456 26.6797C303.997 26.6797 298.888 32.8516 298.888 43.1494C298.888 53.4141 303.997 59.6523 312.456 59.6523Z",
    fill: "#18191B",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M238.941 43.1494C238.775 29.1621 248.429 18.2275 262.396 18.4287C274.339 18.3281 282.234 25.6738 282.765 35.6025L273.609 35.6025C272.846 30.1348 269.23 26.6797 262.728 26.6797L262.031 26.6797C253.272 26.6797 248.13 33.1533 248.13 43.1494C248.13 53.1787 253.272 59.6523 262.031 59.6523L262.728 59.6523C268.566 59.6523 273.775 56.2979 275.301 50.8643L275.434 50.3613L262.396 50.3613L262.396 42.1094L277.325 42.1094C281.073 42.1094 283.097 44.1895 283.097 47.9795L283.097 67.2002L275.301 67.2002L275.301 62.5371C272.282 65.791 267.803 67.8701 261.699 67.8701C248.064 68.0723 238.775 57.1367 238.941 43.1494Z",
    fill: "#18191B",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M200.987 67.2002L200.987 19.0996L210.144 19.0996L210.144 58.9482L236.982 58.9482L236.982 67.2002L200.987 67.2002Z",
    fill: "#18191B",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M185.295 67.2002L181.016 55.8623L161.044 55.8623L156.764 67.2002L147.11 66.6689L165.921 19.0996L176.669 19.0996L195.016 67.2002L185.295 67.2002ZM164.129 47.6104L177.897 47.6104L170.997 29.3633L164.129 47.6104Z",
    fill: "#18191B",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M511.535 67.2002L497.203 46.0352L490.933 52.71L490.933 67.2002L481.776 67.2002L481.776 19.0996L490.933 19.0996L490.933 40.7012L511.137 19.0996L522.482 19.0996L503.738 39.0576L522.88 67.2002L511.535 67.2002Z",
    fill: "#18191B",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M430.883 43.1504C430.784 28.3916 439.31 18.2949 453.642 18.4287C465.817 18.2949 473.049 25.7412 473.613 34.8984L464.457 34.8984C463.428 29.666 459.712 26.6807 453.973 26.6807L453.31 26.6807C445.514 26.5801 439.973 33.0205 440.073 43.1504C440.073 53.3135 445.447 59.6533 453.31 59.6533L453.973 59.6533C459.779 59.6533 463.428 56.7686 464.457 51.4014L473.613 51.4014C473.016 60.9277 465.883 67.9717 453.642 67.8711C439.31 68.0049 430.784 57.9092 430.883 43.1504Z",
    fill: "#18191B",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M419.239 67.2002L414.959 55.8633L394.988 55.8633L390.708 67.2002L381.054 67.2002L399.864 19.0996L410.613 19.0996L428.959 67.2002L419.239 67.2002ZM398.073 47.6113L411.841 47.6113L404.94 29.3643L398.073 47.6113Z",
    fill: "#18191B",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M345.823 67.2002L345.823 19.0996L367.221 19.0996C376.477 19.0996 382.515 24.7012 382.515 34.2275C382.515 43.7539 376.477 49.4229 367.221 49.4229L354.979 49.4229L354.979 67.2002L345.823 67.2002ZM354.979 41.1709L366.192 41.1709C370.837 41.1709 373.325 38.4873 373.325 34.2275C373.325 29.9678 370.837 27.3516 366.192 27.3516L354.979 27.3516L354.979 41.1709Z",
    fill: "#18191B",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgopackIcon);
export default __webpack_public_path__ + "static/media/AlgopackIcon.b88f7057d7e23c685f13f142ec48c3e0.svg";
export { ForwardRef as ReactComponent };